import { Icon } from '@iconify/react';

export interface EmptyProps {
  icon?: string;
  description?: string;
}

export function Empty({ icon, description }: EmptyProps) {
  if (!icon && !description) {
    return null;
  }

  return (
    <div className='m-8 flex flex-col items-center gap-1'>
      {icon && (
        <Icon className='text-default-400' icon={icon} width='48' height='48' />
      )}
      {description && (
        <div className='font-medium text-default-400'>{description}</div>
      )}
    </div>
  );
}
